// src/main/shell/column-resizer.ts
// Shared column-resize chrome for the tree views (symbol grid + log tree). It
// owns ONE thing — the `.vg-resize-highlight` blue wall + the pointer-drag
// plumbing (the smooth, imperative, no-per-frame-rerender part) — so that lives
// in a single place. Each host keeps its OWN column-width MATH, because the two
// genuinely differ: the symbol grid is percentage-based with wall-grab-anywhere;
// the log tree is fixed-px Time/Status columns with a flexing message column.
// The host computes "given this pixel delta, what are the new widths and where
// is the boundary now?"; this class draws + moves the wall and runs the drag.
export class ColumnResizer {
    constructor(wrapper, opts) {
        this.wrapper = wrapper;
        this.opts = opts;
        this.highlight = null;
        this.dragging = false;
    }
    /** Hover affordance: show the wall at `leftX` (px from the wrapper's left,
     *  already centred by the host), or hide it with `null`. No-op mid-drag. */
    setHover(leftX) {
        if (this.dragging)
            return;
        if (leftX === null) {
            this.wrapper.style.cursor = '';
            this.remove();
            return;
        }
        this.wrapper.style.cursor = 'col-resize';
        this.show('vg-resize-hover', leftX);
    }
    /**
     * Run a drag from `startClientX`. On each move, `onDrag(deltaPx)` applies the
     * delta to the host's column model and RETURNS the wall's new `leftX` (so the
     * line follows). `onEnd` commits (persist / sync state). All DOM writes here
     * are direct — there is no per-move re-render, so the drag stays at 60fps.
     */
    beginDrag(startClientX, onDrag, onEnd) {
        this.dragging = true;
        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'col-resize';
        this.show('vg-resize-active', onDrag(0)); // seed the line at the start boundary
        const move = (e) => this.show('vg-resize-active', onDrag(e.clientX - startClientX));
        const up = () => {
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
            this.wrapper.style.cursor = '';
            this.dragging = false;
            this.remove();
            onEnd();
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
    }
    get isDragging() {
        return this.dragging;
    }
    destroy() {
        this.remove();
    }
    show(cls, leftX) {
        if (!this.highlight) {
            this.highlight = document.createElement('div');
            this.highlight.className = 'vg-resize-highlight';
            this.wrapper.appendChild(this.highlight);
        }
        this.highlight.classList.remove('vg-resize-hover', 'vg-resize-active');
        this.highlight.classList.add(cls);
        this.highlight.style.left = `${leftX}px`;
        this.highlight.style.top = `${this.opts.highlightTop()}px`;
    }
    remove() {
        this.highlight?.remove();
        this.highlight = null;
    }
}
//# sourceMappingURL=column-resizer.js.map